import { Stepper, Step, StepLabel } from '@mui/material'
import { IEFStepperProps } from './EFStepper.model'

export function EFStepper({ steps, activeStep }: IEFStepperProps) {
  return (
    <Stepper activeStep={activeStep}>
      {steps.map((label, index) => {
        const stepProps: { completed?: boolean } = {}

        return (
          <Step
            key={label + '-' + index}
            sx={{
              '& > span > span.Mui-completed > svg': {
                fill: '#4CAF50'
              },
              '& > span > span > svg': {
                fontSize: '1.3rem',
                fill: 'var(--nav-button-bg)'
              },

              '& > span > span > svg > text': { fill: '#B0BBC9' },
              '& > span > span > svg.Mui-active': {
                fill: 'var(--blue-button)'
              },
              '& > span > span > svg.Mui-active > text': {
                fill: 'var(--dark)'
              }
            }}
            {...stepProps}
          >
            <StepLabel></StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}
